var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { createUseStyles } from "react-jss";
import { BulkCheckbox, BulkRadioButtons, } from "../../forms/formGrid/FormGridComponents";
import { FormGridColumnTypes } from "../../types/FormGrids";
import { classNames } from "../../utils/classNames";
import { V2TableCell } from "./TableCell";
import { useTableFormClasses } from "./TableForm";
import { V2TableRowComponent } from "./TableRow";
import { useTableContext } from "../../hooks/useTableContext";
import { THEME } from "../../theming/theming";
export function TableBulkAction(props) {
    var _a;
    var gridClassName = useTableContext().gridClassName;
    var cellForm = useTableFormClasses().cellForm;
    var classes = useTableBulkActionClasses();
    var cellClasses = useClasses();
    var form = props.form, dataId = props.dataId, dataTestId = props.dataTestId;
    if (!form)
        return null;
    return (React.createElement(V2TableRowComponent, __assign({ item: form === null || form === void 0 ? void 0 : form.values, rowIndex: 0 }, props, { gridClassName: classNames(gridClassName, classes.bulkAction) }), (form === null || form === void 0 ? void 0 : form.name) &&
        ((_a = props === null || props === void 0 ? void 0 : props.headings) === null || _a === void 0 ? void 0 : _a.map(function (heading, cellIndex) {
            var _a, _b, _c;
            var cellDataId = dataId && "".concat(dataId, "-bulkAction");
            var cellDataTestId = dataTestId && "".concat(dataTestId, "-bulkAction");
            if (cellIndex === 0 && form.bulkActionLabel) {
                return (React.createElement(V2TableCell, __assign({}, props, { colIndex: cellIndex + 1, heading: heading, className: cellForm, key: cellIndex, dataId: cellDataId && "".concat(cellDataId, "-label"), dataTestId: cellDataTestId && "".concat(cellDataTestId, "-label") }),
                    React.createElement("span", { className: "font-weight-bold" }, form.bulkActionLabel)));
            }
            if (!((_a = heading.formComponent) === null || _a === void 0 ? void 0 : _a.bulkAction)) {
                return (React.createElement(V2TableCell, __assign({}, props, { colIndex: cellIndex + 1, heading: heading, className: cellForm, key: cellIndex, dataId: cellDataId && "".concat(cellDataId, "-null"), dataTestId: cellDataTestId && "".concat(cellDataTestId, "-null") })));
            }
            return (React.createElement(V2TableCell, __assign({}, props, { colIndex: cellIndex + 1, heading: heading, className: classNames(typeof heading.formComponent.bulkAction == "string"
                    ? cellClasses.label
                    : "", cellForm), key: cellIndex, dataId: cellDataId && "".concat(cellDataId, "-").concat(cellIndex), dataTestId: cellDataTestId && "".concat(cellDataTestId, "-").concat(cellIndex) }),
                ((_b = heading.formComponent) === null || _b === void 0 ? void 0 : _b.type) === FormGridColumnTypes.Radio && (React.createElement(BulkRadioButtons, { label: typeof heading.formComponent.bulkAction == "string"
                        ? heading.formComponent.bulkAction
                        : undefined, name: form === null || form === void 0 ? void 0 : form.name, formComponent: heading.formComponent })),
                ((_c = heading.formComponent) === null || _c === void 0 ? void 0 : _c.type) === FormGridColumnTypes.Checkbox && (React.createElement(BulkCheckbox, { label: typeof heading.formComponent.bulkAction == "string"
                        ? heading.formComponent.bulkAction
                        : undefined, name: form.name, formComponent: heading.formComponent, dataId: cellDataId && "".concat(cellDataId, "-").concat(cellIndex), dataTestId: cellDataTestId && "".concat(cellDataTestId, "-").concat(cellIndex) }))));
        }))));
}
export var useClasses = function () {
    var useStyles = createUseStyles({
        label: {
            marginTop: 4,
        },
    });
    return useStyles();
};
export var useTableBulkActionClasses = function () {
    var useStyles = createUseStyles({
        bulkAction: {
            backgroundColor: THEME.palette.gray.smoke.color,
        },
    });
    return useStyles();
};
